import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ElementPreviewComponent } from './element-preview.component';
import { YoutubeElementPreviewComponent } from './implementations/youtube-element-preview/youtube-element-preview.component';
import { InstagramElementPreviewComponent } from './implementations/instagram-element-preview/instagram-element-preview.component';
import { TwitterElementPreviewComponent } from './implementations/twitter-element-preview/twitter-element-preview.component';
import { SpotifyElementPreviewComponent } from './implementations/spotify-element-preview/spotify-element-preview.component';
import { WebsiteElementPreviewComponent } from './implementations/website-element-preview/website-element-preview.component';
import { ImageModule } from '../image/image.module';
import { MovieElementPreviewComponent } from './implementations/movie-element-preview/movie-element-preview.component';
import { PinterestElementPreviewComponent } from './implementations/pinterest-element-preview/pinterest-element-preview.component';
import { DefaultElementPreviewComponent } from './implementations/default-element-preview/default-element-preview.component';
import { SafeHtmlModule } from '@/shared/pipes/safe-html/safe-html.module';
import { TrimTextModule } from "@/shared/pipes/trim-text/trim-text.module";

@NgModule({
  declarations: [
    DefaultElementPreviewComponent,
    PinterestElementPreviewComponent,
    MovieElementPreviewComponent,
    ElementPreviewComponent,
    YoutubeElementPreviewComponent,
    InstagramElementPreviewComponent,
    TwitterElementPreviewComponent,
    SpotifyElementPreviewComponent,
    WebsiteElementPreviewComponent,
  ],
  imports: [
    CommonModule,
    ImageModule,
    SafeHtmlModule,
    TrimTextModule,
  ],
  exports: [ElementPreviewComponent],
})
export class ElementPreviewModule { }
